import { createApiQuery } from '@/hooks/use-api-query';
import { get } from '@/libs/http';
import { HomeReq, HomeRes } from '@/types/api/hall/home.d';
import type { GAME_TYPE } from '../const/game';

export enum CardType {
  BANNER = 1,
  RECENTLY_PLAYED = 2,
  CASINO = 3,
  FANTASY = 4,
  RUMMY = 5,
  SPORTS = 6,
}

export enum RummyIconType {
  Rournament = 1,
  Points = 2,
  Deals = 3,
}

export interface CardNormalItem {
  game_type?: GAME_TYPE;
  id: number;
  name: string;
  icon: string;
  provider: string;
  currency_type: string[];
  // 1. 正常 2. 维护 3. 关闭
  status: number;
  // rummy
  game_id: number;
  rummy_icon_type: RummyIconType;
}

export interface CardBannerItem {
  /**
   * 广告位UUID
   */
  ad_place_uuid: string;
  /**
   * 图片地址
   */
  img: string;
  img_json: Record<string, string>;
  /**
   * 模块名称
   */
  module_name: string;
  /**
   * 跳转link
   */
  link: string;
  /**
   * banner uuid
   */
  uuid: string;
  /**
   * 是否有跳转通用活动详情页的需求
   */
  has_activity_common_detail?: boolean;
}

export enum LineupStatus {
  LINEUP_STATUS_NONE = 0,  // 未官宣
  LINEUP_STATUS_OUT = 1,  // 已官宣
}

export enum MatchItemStatus {
  MATCH_STATUS_UNKNOWN = 0,  // 未知
  MATCH_STATUS_NOT_STARTED = 1,  // 未开始
  MATCH_STATUS_IN_PROGRESS = 2,  // 进行中
  MATCH_STATUS_COMPLETED = 3,  // 已结束
  MATCH_STATUS_ABANDONED = 4,  // 已取消
}
export interface CardFantasyItem {
  id: string;
  tour_id: string;
  full_name: string;
  short_name: string;
  start_time: string;
  status: MatchItemStatus;
  lineup_status: LineupStatus;
  is_prize_coming_soon?: boolean;
  price_pool_list: {
    currency_type: string,
    iconUrl: string,
    price_pool: number,
    symbol: string,
  }[],
  squads: {
    full_name: string;
    logo_url: string;
    short_name: string;
  }[];
}

export interface CardRummyItem {
  id?: string;
  /** 游戏ID: 203-Points, 205-Deals, 206-Points比赛, 207-Deals比赛 */
  game_id: number;
  /** 玩法类型, Points, 2Deals, 3Deals */
  game_type: string;
  /** 比赛形式: 1:免费赛 2:锦标赛 3:收费赛 */
  match_form: number;
  /** 比赛类型: 1:定时赛 2:人满赛 */
  match_type: number;
  /** 比赛名称 */
  match_name: string;
  /** Points为底注, Deals为入场扣除 */
  base_ante: number;
  /** Points为入场资产下限, Deals为最大可赢奖数额 */
  entry_min: number;
  /** 游戏局数（仅deals） */
  game_count: number;
  /** 座位数：2人场或6人场 */
  seat_count: number;
  /** 虚拟在线人数 */
  online_user: number;
  /** 最大参赛人数 */
  max_user_num: number;
  /** 报名费（金币类型已/1000） */
  fee_num: number;
  /** 比赛开始时间（Unix时间戳） */
  match_begin_time: number;
  /** 赛事总奖金 */
  total_reward: number;
  /**赛事奖励人数 */
  reward_user_num: number;
  /** 推荐类型: cash, match */
  recommend_type: 'cash' | 'match';
  /** 场次level */
  level?: number;
  /** 赛事配置id */
  match_config_id?: number;
}

export interface RankPlayer {
  place: number;
  player: string;
  avatar: string;
  wager: string;
}

export interface RankData {
  title: string;
  prizePool: string;
  backgroundImage?: string;
  players: RankPlayer[];
  buttonText: string;
  buttonLink?: string;
}

export const getHomeInfo = (params: HomeReq) => get<HomeRes>('/hall/v1/home', { params });

export const useHomeInfo = createApiQuery(getHomeInfo, (params: HomeReq) => ['homeInfo', params]);
